import React from "react";
import Modal from "./Modal";
import { Close, Loader } from "../icons";
import { useGetSingleItemQuery } from "../../store/api/itemApi";
import itmImg from "../../assets/item-thumbnail.png";

export default function ItemDetailsModal({ open, onClose, itemId }) {
  const { data, isLoading, error } = useGetSingleItemQuery(itemId, {
    skip: !itemId || !open,
  });

  const item = data?.data;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={null}
      panelClassName="max-w-[500px] p-0"
      centered={false}
    >
      <div className="w-full">
        <div className="flex items-center justify-between border-b border-[#E5E5E5] px-7 py-5">
          <div>
            <p className="text-xl font-bold leading-6 text-black">
              Item Details
            </p>
            <p className="leading-[17px] text-[#868686] text-xs mt-1">
              Detailed view of inventory item
            </p>
          </div>
          <button onClick={onClose} aria-label="close">
            <Close />
          </button>
        </div>

        <div className="p-7">
          {isLoading && (
            <div className="flex flex-col items-center justify-center py-10 gap-2">
              <Loader />
              <p className="text-sm text-gray-500">Loading details...</p>
            </div>
          )}

          {error && !isLoading && (
            <div className="text-red-500 text-center py-10">
              Failed to load item details.
            </div>
          )}

          {!isLoading && item && (
            <div className="space-y-6 text-black">
              <div className="flex justify-center">
                <div className="w-40 h-40 rounded-lg overflow-hidden border border-gray-200">
                  <img
                    src={item.itemPicture?.secure_url || itmImg}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => { e.target.onerror = null; e.target.src = itmImg; }}
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-y-4 gap-x-6 text-sm">
                <div>
                  <p className="text-[#878686] text-xs mb-1">Item ID</p>
                  <p className="font-semibold break-all">{item._id}</p>
                </div>
                <div>
                  <p className="text-[#878686] text-xs mb-1">Name</p>
                  <p className="font-semibold">{item.name}</p>
                </div>
                <div>
                  <p className="text-[#878686] text-xs mb-1">Price</p>
                  <p className="font-semibold">Rs {item.itemPrice}</p>
                </div>
                <div>
                  <p className="text-[#878686] text-xs mb-1">Status</p>
                  <span className="inline-block bg-[#E5FFF6] text-[#2C765C] px-2.5 py-1 rounded-full text-xs font-semibold capitalize">
                    {item.status}
                  </span>
                </div>
                <div>
                  <p className="text-[#878686] text-xs mb-1">Category</p>
                  <p className="font-semibold capitalize">{item.itemCategory?.name || "N/A"}</p>
                </div>
                <div>
                  <p className="text-[#878686] text-xs mb-1">Vendor</p>
                  <p className="font-semibold capitalize">{item.itemVendor?.name || "N/A"}</p>
                </div>
                <div className="col-span-2">
                  <p className="text-[#878686] text-xs mb-1">Created By</p>
                  <p className="font-semibold">
                    {item.createdBy?.name || "Unknown"} <span className="font-normal text-gray-500 text-xs">({item.createdBy?.email || "No email"})</span>
                  </p>
                </div>
                <div>
                  <p className="text-[#878686] text-xs mb-1">Created At</p>
                  <p className="font-semibold">
                    {new Date(item.createdAt).toLocaleDateString("en-US", {
                      timeZone: "Asia/Karachi",
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })}
                  </p>
                </div>
                <div>
                  <p className="text-[#878686] text-xs mb-1">Last Updated</p>
                  <p className="font-semibold">
                    {new Date(item.updatedAt).toLocaleDateString("en-US", {
                      timeZone: "Asia/Karachi",
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
